<div class="modal fade confirmation-modal" id="confirmationModal" #confirmationModal tabindex="-1" role="dialog">
    <div class="modal-dialog modal-full-screen">
        <div class="modal-content confirmation-content">
            <div class="modal-body confirmation-body" [class.modal-body-warning-bar]="warningBar">
                <div class="d-flex align-items-center mb-1">
                    <span class="title">{{headerText}}</span>
                    <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="container-fluid mt-2 p-0">
                    <div class="row message-row">
                        <div class="mt-4 mb-3 ml-4 mr-3">
                            <p class="message">{{bodyText}}</p>
                            <form [formGroup]="includingFollowingModeForm" class="text-dimmed"
                                *ngIf="showRadioButtonsToChooseWhetherIncludeFollowing">
                                <div>
                                    <input id="just-this" type="radio" class="action-mode-input" value="just-this"
                                        formControlName="actionMode">
                                    <label class="ml-1 action-mode-label" for="just-this" translate>RecurringClassConfirmation.ThisClassOption</label>
                                </div>

                                <div class="mt-1">
                                    <input id="this-and-following" type="radio" class="action-mode-input"
                                        value="this-and-following" formControlName="actionMode">
                                    <label class="ml-1 action-mode-label" for="this-and-following" translate>RecurringClassConfirmation.ThisAndFollowingOption</label>
                                </div>
                                <div class="mt-1" *ngIf="showChangedFields">
                                    <span translate [translateParams]="{fields : fields}">RecurringClassConfirmation.ChangedFields</span>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="row mt-2 justify-content-end">
                        <button class="col-auto btn bc-button mr-2" (click)="onClose()"
                            translate>General.Dismiss</button>
                        <button class="col-auto btn btn-success ml-2 mr-3" (click)="onConfirm()"
                            [disabled]="confirmDisabled" translate>General.Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
